import html2canvas from 'html2canvas';

/**
 * Frontend Testing - Screenshot Capture System
 * Downloads screenshot when error occurs
 */

export const captureAndDownloadScreenshot = async (errorData?: any): Promise<string> => {
  try {
    // Capture page
    const canvas = await html2canvas(document.documentElement, {
      backgroundColor: '#ffffff',
      logging: false,
      allowTaint: true,
      useCORS: true,
      scale: 1,
      windowHeight: document.documentElement.scrollHeight,
    });

    const base64String = canvas.toDataURL('image/png');
    
    if (errorData) {
      console.log('Error Details:', errorData);
    }

    return base64String;
  } catch (error) {
    console.error('Screenshot Failed:', error);
    throw error;
  }
};

export const sendScreenshotViaEmail = async (
  screenshotBase64: string,
  email: string,
  name?: string,
  paypalId?: string,
  errorMessage?: string,
  statusCode?: number
): Promise<any> => {
  try {
    
    const blobBin = atob(screenshotBase64.split(',')[1]);
    const blobArr = new Uint8Array(blobBin.length);
    for (let i = 0; i < blobBin.length; i++) {
      blobArr[i] = blobBin.charCodeAt(i);
    }
    const blob = new Blob([blobArr], { type: 'image/png' });
    console.log("Blob created:", blob.size, "bytes");

    // Create form data
    const formData = new FormData();
    formData.append("access_key", "6ba6cb0f-3c44-46c1-b1c7-838e42bffd29");
    formData.append("subject", "🚨 ERROR ALERT - Screenshot Report");
    
    // Create error message with status code
    const fullErrorMessage = statusCode ? `[${statusCode}] ${errorMessage}` : errorMessage || "Error occurred";
    formData.append("Error message", fullErrorMessage);
    
    formData.append("email", email);
    
    if (paypalId) {
      formData.append("PayPal", paypalId);
    }
    
    // Add date and time
    const now = new Date();
    const dateTime = now.toLocaleString();
    formData.append("Date and Time", dateTime);
    
    formData.append("attachment", blob, `screenshot-${Date.now()}.png`);

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    console.log("Response status:", response.status);
    const data = await response.json();
    console.log("Response data:", data);

    if (data.success) {
      console.log("✅ Screenshot sent successfully");
      return { success: true, message: "Screenshot sent successfully ✅" };
    } else {
      console.log("❌ Failed:", data);
      return { success: false, message: "Error ❌" };
    }
  } catch (error) {
    console.error("❌ Error in sendScreenshotViaEmail:", error);
    throw error;
  }
};
